export default __webpack_public_path__ + "images/8f47aa7ac0b4690a3f49b23f7d4a1292.svg";